import { Component, OnInit ,Input} from '@angular/core';
import {TextBoxComponentsLibService}  from '../text-box-components-lib.service';
@Component({
  selector: 'cmpts-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css']
})
export class CardComponent implements OnInit {
 data:any={};
  constructor( private service: TextBoxComponentsLibService) { }
  ngOnInit(): void {
    this.service.getDocument().subscribe((data:any)=> {
     if(data && Object.keys(data).length>0){
       this.data["policyLine"]=data[0].document.businessInfo.policyIdentifier+"."+data[0].document.businessInfo.lineIdentifier;
       this.data["inceptionDate"]=data[0].document.inceptionDate;
       this.data["insured"]=data[0].document.businessInfo.insured.name;
       this.data["policyLineStatus"]=data[0].document.businessInfo.policyLineStatus;
       this.data["lastUpdateUsr"]="Raviganesh Madhavan";
       this.data["carrier"]=data[0].document.businessInfo.carrier.name;
       this.data["industrySegment"]=data[0].document.businessInfo.industrySegment;
       this.data["incomingUnderWriter"]=data[0].document.businessInfo.underwriter.name;
       this.data["revisionHistory"]="";
     }
   });
   
 }

 ngOnChanges(changes: any):void{
   this.service.getDocument().subscribe((data:any)=> {
     if(data && Object.keys(data).length>0){
       this.data["policyLine"]=data[0].document.businessInfo.policyIdentifier+"."+data[0].document.businessInfo.lineIdentifier;
       this.data["inceptionDate"]=data[0].document.inceptionDate;
       this.data["insured"]=data[0].document.businessInfo.insured.name;
       this.data["policyLineStatus"]=data[0].document.businessInfo.policyLineStatus;
       this.data["lastUpdateUsr"]="Raviganesh Madhavan";
       this.data["carrier"]=data[0].document.businessInfo.carrier.name;
       this.data["industrySegment"]=data[0].document.businessInfo.industrySegment;
       this.data["incomingUnderWriter"]=data[0].document.businessInfo.underwriter.name;
       this.data["revisionHistory"]="";
     }
   });
  }
 
}
